import axios from 'axios';

const baseURL = 'https://career.vlu.edu.vn/api/';
const headers = {
  Accept: 'application/json',
  'Content-Type': 'application/json'
};

const instance = axios.create({
  baseURL,
  headers
});
instance.interceptors.response.use(
  response => response.data,
  error => Promise.reject(error)
);
export default instance;
